import { Component, inject, input } from '@angular/core';
import { CancellationFlowDetailsResponse } from 'src/app/_types/cancellation.types';

import { TaskCancellationCardComponent } from './task-cancellation-card.component';
import { TaskCancellationsService } from './task-cancellations.service';

/**
 * Under the policy: every cancellation of the opened flow, newest first with
 * the called-off ones last, one card each — the running one, if any, open.
 * Read from the affaire's batch; nothing is fetched here.
 */
@Component({
  selector: 'app-task-cancellations',
  standalone: true,
  imports: [TaskCancellationCardComponent],
  template: `
    @if (cancellations.length) {
      <div class="task-cancellations">
        @for (cancellation of cancellations; track cancellation.id) {
          <app-task-cancellation-card
            [cancellation]="cancellation"
            [layer]="layer()"
          />
        }
      </div>
    }
  `,
  styles: `
    :host {
      display: block;
    }

    /* On the wrapper, so that no cancellation leaves no gap. */
    .task-cancellations {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 12px;
    }
  `,
})
export class TaskCancellationsComponent {
  private readonly store = inject(TaskCancellationsService);

  /** The host sheet's layer; the cards' forms open one above it. */
  readonly layer = input(0);

  protected get cancellations(): CancellationFlowDetailsResponse[] {
    return this.store.ofOpenedFlow;
  }
}
